// Inline SVG rather than an icon package: four kilobytes of markup instead
// of a dependency, and they inherit currentColor so themes just work.
type P = { size?: number; className?: string }
const base = (size: number, className?: string) => ({
  width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
  stroke: 'currentColor', strokeWidth: 1.75,
  strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const,
  className, 'aria-hidden': true,
})

export const IconUsers = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
)
export const IconPatients = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}>
    <path d="M19 4h-3V2H8v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z" />
    <path d="M12 11v5M9.5 13.5h5" />
  </svg>
)
export const IconAudit = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" /><path d="M14 2v6h6" />
    <path d="M8 13h6M8 17h4" />
  </svg>
)
export const IconSearch = ({ size = 15, className }: P) => (
  <svg {...base(size, className)}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.2-3.2" /></svg>
)
export const IconPlus = ({ size = 15, className }: P) => (
  <svg {...base(size, className)}><path d="M12 5v14M5 12h14" /></svg>
)
export const IconLogout = ({ size = 15, className }: P) => (
  <svg {...base(size, className)}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="m16 17 5-5-5-5M21 12H9" />
  </svg>
)
export const IconClose = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}><path d="M18 6 6 18M6 6l12 12" /></svg>
)
export const IconCheck = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}><path d="m20 6-11 11-5-5" /></svg>
)
export const IconAlert = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}>
    <path d="M12 9v4M12 17h.01" />
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
  </svg>
)
export const IconGoogle = ({ size = 18 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.4a5.5 5.5 0 0 1-2.4 3.6v3h3.9c2.3-2.1 3.6-5.2 3.6-8.8Z" />
    <path fill="#34A853" d="M12 24c3.2 0 6-1.1 8-2.9l-3.9-3c-1.1.7-2.5 1.2-4.1 1.2-3.1 0-5.8-2.1-6.7-5H1.3v3.1A12 12 0 0 0 12 24Z" />
    <path fill="#FBBC05" d="M5.3 14.3a7.2 7.2 0 0 1 0-4.6V6.6H1.3a12 12 0 0 0 0 10.8l4-3.1Z" />
    <path fill="#EA4335" d="M12 4.8c1.8 0 3.3.6 4.6 1.8l3.4-3.4A12 12 0 0 0 1.3 6.6l4 3.1c.9-2.9 3.6-5 6.7-5Z" />
  </svg>
)

export const IconEye = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}>
    <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z" /><circle cx="12" cy="12" r="3" />
  </svg>
)
export const IconEdit = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}>
    <path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </svg>
)
export const IconTrash = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}>
    <path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /><path d="M10 11v6M14 11v6" />
  </svg>
)

export const IconProducts = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}>
    <path d="M21 8V6a2 2 0 0 0-1.1-1.8l-7-3.5a2 2 0 0 0-1.8 0l-7 3.5A2 2 0 0 0 3 6v12a2 2 0 0 0 1.1 1.8l7 3.5a2 2 0 0 0 1.8 0l7-3.5A2 2 0 0 0 21 18v-2" />
    <path d="M3.3 5.2 12 9.6l8.7-4.4M12 22V9.6" />
  </svg>
)

export const IconRx = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" /><path d="M14 2v6h6" />
    <path d="M8 12h3a2 2 0 0 1 0 4H8v-4Zm0 4v4m3 0 4-4" />
  </svg>
)

export const IconBilling = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}>
    <path d="M5 3h14a1 1 0 0 1 1 1v17l-3-2-3 2-3-2-3 2-3-2V4a1 1 0 0 1 1-1Z" />
    <path d="M8 8h8M8 12h8M8 16h4" />
  </svg>
)

export const IconAnalytics = ({ size = 16, className }: P) => (
  <svg {...base(size, className)}>
    <path d="M3 3v16a2 2 0 0 0 2 2h16" />
    <path d="M7 15.5V12M12 15.5V8M17 15.5v-5.5" />
  </svg>
)

export const IconMenu = ({ size = 18, className }: P) => (
  <svg {...base(size, className)}><path d="M3 6h18M3 12h18M3 18h18" /></svg>
)
